import React from 'react';
import { ComparisonTable } from '../data/responses';

interface ComparisonMatrixProps {
  comparison: ComparisonTable;
}

export const ComparisonMatrix: React.FC<ComparisonMatrixProps> = ({ comparison }) => {
  return (
    <div className="mt-4 border border-purple-200 rounded-xl overflow-hidden shadow-lg bg-white">
      <div className="bg-gradient-to-r from-purple-600 to-indigo-600 px-4 py-2">
        <div className="text-xs font-bold text-white uppercase tracking-wide flex items-center gap-2">
          <span>⚖️</span> Comparison Matrix
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-purple-50 to-indigo-50">
              {comparison.headers.map((header, i) => (
                <th
                  key={i}
                  className="p-3 text-left text-xs font-bold text-purple-700 border-b border-purple-200 whitespace-nowrap"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {comparison.rows.map((row, i) => (
              <tr
                key={i}
                className="hover:bg-purple-50 transition-colors border-b border-gray-100 last:border-b-0"
              >
                {row.map((cell, j) => (
                  <td
                    key={j}
                    className={`p-3 text-sm ${
                      j === 0
                        ? 'font-semibold text-gray-800'
                        : 'text-gray-700'
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Analysis indicator */}
      <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-2 border-t border-purple-100">
        <div className="text-[10px] text-purple-600 flex items-center justify-center gap-1">
          <span className="animate-pulse">●</span>
          AI-powered comparative analysis completed
        </div>
      </div>
    </div>
  );
};
